module.exports = __webpack_public_path__ + "img/1530586289.d265eb16.jpg";